export const baseStrapiGetAttributes = (data: object) => {
  if (!data) { return null }
  if ((data instanceof Object) === false) { return null }
  return baseFindValByKeyInObject(toRaw(data), 'attributes')
}
